const formatTag = (tag) => ({
  objectId: tag.id,
  classRoom: { objectId: tag.space },
  name: tag.name,
  createdAt: tag.createdAt,
  updatedAt: tag.updatedAt,
});

export default formatTag;
